import 'reflect-metadata';
import 'simplebar/src/simplebar.css';
import '@shared/utils/i18next';

import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import Logger from 'js-logger';
import { App } from '@app/App';
import reportWebVitals from './reportWebVitals';

const root = createRoot(document.getElementById('root') as HTMLElement);

// eslint-disable-next-line react-hooks/rules-of-hooks
Logger.useDefaults();

async function enableMocking() {
  if (process.env.NODE_ENV !== 'development') {
    return;
  }

  const { worker } = await import('./app/mocks/index');

  return worker.start();
}

enableMocking().then(() => {
  root.render(
    <StrictMode>
      <Suspense fallback={'loading'}>
        <App />
      </Suspense>
    </StrictMode>
  );
});

reportWebVitals();
